module.exports = __webpack_public_path__ + "img/dell-tech-logo-grey.8829d318.svg";